import { isEqual, isObject, transform } from 'lodash';

type PlainObject = Record<string, unknown>;

export function objectSubtract(
  originalObject: object,
  originalBase: object,
): PlainObject {
  function changes(object: PlainObject, base: PlainObject): PlainObject {
    const accumulator: PlainObject = {};

    return transform(
      object,
      (acc: PlainObject, value, key) => {
        if (base[key] === undefined) {
          acc[key] = value;
        } else if (!isEqual(value, base[key])) {
          acc[key] =
            isObject(value) && isObject(base[key])
              ? changes(value as PlainObject, base[key] as PlainObject)
              : value;
        }
      },
      accumulator,
    );
  }

  return changes(
    originalObject as PlainObject,
    originalBase as PlainObject,
  );
}
